import { useMemo } from 'react';

import { ApplianceModel, FilterOption } from '@common/models';
import {
    filterAllEntries,
    getSelectedFiltersMap,
    initializeFiltersOptions,
} from '@core/components/filters/filterUtils';
import { useAppSelector } from '@redux/hooks';
import { DishwasherFilters, selectDishwasherFilters } from '@redux/slices/dishwasherSlice';

import useDishwasher from './useDishwasher';

type useFilteredDishwashersReturn = {
    filteredDishwashers: ApplianceModel[];
    dishwasherFilters: DishwasherFilters;
};

// TODO: consolidte with useFilteredSinks
const useFilteredDishwashers = (): useFilteredDishwashersReturn => {
    const { browsedDishwashers } = useDishwasher();
    const _dishwasherFilters = useAppSelector(selectDishwasherFilters);

    const initialFilterOptions: DishwasherFilters = useMemo(() => {
        let initialFilters: DishwasherFilters = {};
        const setDishwasherFilters = (val: DishwasherFilters) => {
            initialFilters = val;
        };
        if (browsedDishwashers.length > 0) {
            initializeFiltersOptions(browsedDishwashers, setDishwasherFilters);
        }
        return initialFilters;
    }, [browsedDishwashers]);

    const dishwasherFilters = useMemo(() => {
        return _dishwasherFilters ?? initialFilterOptions;
    }, [_dishwasherFilters, initialFilterOptions]);

    const filteredDishwashers = useMemo(() => {
        const selectedFilters: Map<string, FilterOption[]> = getSelectedFiltersMap(dishwasherFilters);
        return filterAllEntries(Array.from(selectedFilters.entries()), browsedDishwashers);
    }, [dishwasherFilters, browsedDishwashers]);

    return {
        filteredDishwashers,
        dishwasherFilters,
    };
};

export default useFilteredDishwashers;
